import { Box } from '@mui/material';
import type { Announcement } from '../../../hooks/api/useAnnouncements';
import { AnnouncementsTableDesktop } from './AnnouncementsTableDesktop';
import { AnnouncementsTableMobile } from './AnnouncementsTableMobile';

export type AnnouncementsTableProps = {
  announcements: Announcement[];
  onOpen: (announcement: Announcement) => void;
  onDelete: (announcement: Announcement) => Promise<void>;
};

export const AnnouncementsTable = (props: AnnouncementsTableProps) => (
  <>
    <Box sx={{ display: { xs: 'none', md: 'block' }, mt: 24 }}>
      <AnnouncementsTableDesktop {...props} />
    </Box>
    <Box sx={{ display: { xs: 'block', md: 'none' }, mt: 24 }}>
      <AnnouncementsTableMobile {...props} />
    </Box>
  </>
);
